export default function Stack() {
  return {
    MuiStack: {
      root: {
        styleOverrides: {}
      }
    }
  };
}
